import { Dispatch, SetStateAction, useMemo } from 'react';
import { MenuItem } from '../../../_components/OverviewCreator/components/OverviewCommandBar/OverviewCommandBar';
import { deepCopy } from '../../../Utilities/ObjectEx';
import { tpEntityAddDefaults } from '../../common/tpEntityFactory';
import { IRule } from '../rule/IRule';
import { useTranslation } from '../../../Locales/i18n/localizationService';

export const useRuleOverviewMenuItems = ({
    setItems,
    setIsNewlyCreated,
    preNewItem,
    preCopyItem,
	setOpenImportRulesByApiPanel,
}: {
    setItems: Dispatch<SetStateAction<IRule[]>>;
    setIsNewlyCreated: (isNew: boolean) => void;
    preNewItem?: (item: IRule) => void;
    preCopyItem?: (item: IRule) => void;
	setOpenImportRulesByApiPanel: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const { t } = useTranslation();
    return useMemo((): MenuItem<IRule>[] => {
        return [
            {
                key: 'new',
                text: t("Common.New"),
                iconProps: { iconName: 'Add' },
                onClick: (selectedItems, setPanelItem) => {
                    const emptyItem = {} as IRule;
					tpEntityAddDefaults.workProfileRule(emptyItem);
                    preNewItem?.(emptyItem);
                    setPanelItem(emptyItem);
                    setIsNewlyCreated(true);
                },
            },
            {
                key: 'newImportByHoliday',
                text: 'Import by holidays', // language.Common.New,
                iconProps: { iconName: 'Add' },
                onClick: (selectedItems, setPanelItem) => {
					setOpenImportRulesByApiPanel(true);
                },
            },
            {
                key: 'edit',
                text: t("Common.Edit"),
                iconProps: { iconName: 'Edit' },
                onClick: (selectedItems, setPanelItem) => {
                    setPanelItem(selectedItems[0]);
                },
                shouldDisable: selectedItems => selectedItems?.length !== 1,
            },
            {
                key: 'delete',
                text: t("Common.Delete"),
                iconProps: { iconName: 'Delete' },
                onClick: selectedItems => {
                    setItems(items => items.filter(item => !selectedItems.some(selectedItem => selectedItem.id === item.id)));
                },
                shouldDisable: selectedItems => !selectedItems?.length,
            },
            {
                key: 'copy',
                text: t("Common.Copy"),
                iconProps: { iconName: 'Copy' },
                onClick: (selectedItems, setPanelItem) => {
                    const item = deepCopy(selectedItems[0]);
                    preCopyItem?.(item);
                    setPanelItem(item);
                    setIsNewlyCreated(true);
                },
                shouldDisable: selectedItems => selectedItems?.length !== 1,
            },
        ];
    }, [preCopyItem, preNewItem, setIsNewlyCreated, setItems, setOpenImportRulesByApiPanel, t]);
};
